const values = {
    PAPERS_GENERATOR: 'papersGenerator',
    SIGNATURE_VERIFICATOR: 'signatureVerificator'
}

export default values;